import { render, staticRenderFns } from "./cancelledOrdersItem.vue?vue&type=template&id=6ab0e586"
import script from "./cancelledOrdersItem.vue?vue&type=script&lang=js"
export * from "./cancelledOrdersItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports